import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableData,
  TableBody,
} from '@welldev-group/rcl-table';
import { Toggle } from '@welldev-group/react-comp-lib';
import EntityManagementSection from './EntityManagementSection';

const WorkspaceManagementSection = ({
  className,
  workspaces,
  outOfLimit,
  limit,
  activeWorkspacesCount,
  setDeactivateWorkspacesIDs,
}) => {
  const handleToggleChange = workspaces => {
    setDeactivateWorkspacesIDs(prevState => {
      const newState = [...prevState];
      const workspaceId = workspaces.id;
      const newWorkspaceState = !workspaces.active;
      const indexOfWorkspace = newState.indexOf(workspaceId);
      const storedInPrevState = indexOfWorkspace !== -1;

      if (!newWorkspaceState && !storedInPrevState) {
        newState.push(workspaceId);

        return newState;
      }

      if (newWorkspaceState && storedInPrevState) {
        newState.splice(indexOfWorkspace, 1);

        return newState;
      }

      return newState;
    });
  };

  return (
    <EntityManagementSection
      className={className}
      outOfLimit={outOfLimit}
      title={I18n.t('components.subscription.entity_section.title.workspace')}
      limitText={I18n.t(
        'components.subscription.entity_section.limit_info.text.workspace',
        {
          count: limit,
        },
      )}
      limitAlertText={I18n.t(
        'components.subscription.entity_section.limit_alert.workspace',
        {
          count: activeWorkspacesCount,
        },
      )}
      entityListTable={
        <Table
          className={classNames('entity-management-section__table', {
            'entity-management-section__table--warning-border': outOfLimit,
          })}
        >
          <TableHead>
            <TableRow>
              <TableHeader>
                {I18n.t(
                  'components.subscription.entity_section.table.header.workspace_name',
                )}
              </TableHeader>
              <TableHeader>
                {I18n.t(
                  'components.subscription.entity_section.table.header.identifier',
                )}
              </TableHeader>
              <TableHeader />
            </TableRow>
          </TableHead>
          <TableBody>
            {workspaces.map(workspace => (
              <TableRow key={workspace.id}>
                <TableData>{workspace.name}</TableData>
                <TableData>{workspace.identifier}</TableData>
                <TableData
                  className="entity-management-section__table-toggle-wrapper"
                  align="right"
                >
                  <Toggle
                    isChecked={workspace.active}
                    size="tiny"
                    disabled={!workspace.changeable}
                    onChange={() => handleToggleChange(workspace)}
                  />
                </TableData>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      }
    />
  );
};

WorkspaceManagementSection.defaultProps = {
  className: '',
  workspaces: [],
  limit: 0,
  outOfLimit: false,
  activeWorkspacesCount: 0,
  setDeactivateWorkspacesIDs: () => {},
};

WorkspaceManagementSection.propTypes = {
  className: PropTypes.string,
  workspaces: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool,
      changeable: PropTypes.bool,
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      identifier: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
    }),
  ),
  limit: PropTypes.number,
  outOfLimit: PropTypes.bool,
  activeWorkspacesCount: PropTypes.number,
  setDeactivateWorkspacesIDs: PropTypes.func,
};

export default WorkspaceManagementSection;
